var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',{attrs:{"id":"overlay"}},[_c('div',{staticClass:"spinner"}),_c('br'),_vm._v(" Loading... ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }